function Maybe(value) {
    const Nothing = {
        bind(fn) {
            return this;
        },
        isNothing() {
            return true;
        },
        val() {
            throw new Error("cannot call val() nothing");
        },
        maybe(def, fn) {
            return def;
        }
    };

    function Something(value) {
        return {
            bind(fn) {
                return Maybe(fn.call(this, value));
            },
            isNothing() {
                return false;
            },
            val() {
                return value;
            },
            maybe(def, fn) {
                return fn.call(this, value);
            }
        };
    }

    if (typeof value === 'undefined' || value === null)
        return Nothing;

    return Something(value);
}
export default Maybe;